<wr-base-dialog
  [header]="title || 'Bild hochladen'"
  [status]="mandatory ? 'danger' : 'info'"
  [submitText]="'Abschließen'"
  [cancelText]="'Abbrechen'"
  [disableSubmit]="!canSubmit()"
  [submitResponse]="submit.bind(this)"
>
  @if (!attachmentsRequired()) {
    <div class="mandatory-warning">
      Sie müssen mindestens ein Bild hochladen.
    </div>
  }
  @if (!nameWasProvided()) {
    <div class="mandatory-warning">
      Sie müssen Ihren Namen eingeben.
    </div>
  }
  <hau-form [formGroup]="form">
    @if (!userIdProvided()) {
      <hau-form-field label="Name" cols="12">
        <input nbInput fullWidth formControlName="name" placeholder="Name eingeben"/>
      </hau-form-field>
    }
    <hau-form-field label="Kommentar" cols="12">
      <textarea
        nbInput
        fullWidth
        rows="4"
        formControlName="comment"
        placeholder="Kommentar eingeben"
      >
      </textarea>
    </hau-form-field>
    <hau-form-field label="Bilder" cols="12">
      <wr-multi-attachment-control formControlName="attachments" class="picture-upload">
      </wr-multi-attachment-control>
    </hau-form-field>
    <hau-form-field label="E-Mail an Hausverwalter schicken" cols="12">
      <nb-checkbox formControlName="sendEmailToPropertyManager"></nb-checkbox>
    </hau-form-field>
  </hau-form>
</wr-base-dialog>
